"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _renderProps = require("../../../libs/renderProps");

var _assets = _interopRequireDefault(require("@insided/deprecated-preact-components/assets"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var TextInputFilter = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(TextInputFilter, _Component);

  var _super = _createSuper(TextInputFilter);

  function TextInputFilter(props) {
    var _this;

    (0, _classCallCheck2.default)(this, TextInputFilter);
    _this = _super.call(this, props);
    _this.state = {
      data: props.selectedFilterItems || ''
    };
    return _this;
  }

  (0, _createClass2.default)(TextInputFilter, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var children = this.props.children;
      var data = this.state.data;
      var inputClassName = 'qa-search-box-filter';
      return (0, _preact.h)("div", null, (0, _preact.h)("div", {
        className: "overview__filters-box-content"
      }, (0, _preact.h)("div", {
        className: "control-search-box"
      }, (0, _preact.h)("div", null, (0, _preact.h)(_assets.default, {
        width: 16,
        height: 16,
        icon: "search"
      }), (0, _preact.h)("input", {
        className: inputClassName,
        type: "text",
        value: data,
        placeholder: "Contains",
        maxLength: 500,
        onInput: function onInput(e) {
          return _this2.setState({
            data: e.target.value
          });
        }
      }), data && (0, _preact.h)(_assets.default, {
        icon: "close",
        width: 16,
        height: 16,
        onClick: function onClick() {
          return _this2.setState({
            data: ''
          });
        }
      })))), (0, _renderProps.extractRenderPropsChildren)(children)({
        data: data,
        isApplyButtonDisabled: data.length === 0
      }));
    }
  }]);
  return TextInputFilter;
}(_preact.Component);

(0, _defineProperty2.default)(TextInputFilter, "create", function (config) {
  return _objectSpread({
    component: TextInputFilter,
    type: 'filter',
    getPillDisplayValue: function getPillDisplayValue(data) {
      return data;
    }
  }, config);
});
var _default = TextInputFilter;
exports.default = _default;